// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_07a5170","title":"_aa9da7e","recordTitle":"_662cb19","recordTotal":"_cc53930","recordValue":"_a2a17e9","separator":"_78f8a2c","bonusCurrency":"_bc752c0"};